import { FC } from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { IconName } from '@shinetools/sunshine-icons';

import { FCWithChildren } from 'common/types';
import SunshineIcon from 'components/_core/SunshineIcon';

const ItemPictureContainer: FCWithChildren = ({ children }) => {
  return (
    <Flex
      alignItems="center"
      aspectRatio={1}
      backgroundColor="grey.200"
      borderRadius="radius-12"
      color="grey.700"
      justifyContent="center"
      width="40px"
    >
      {children}
    </Flex>
  );
};

type SunshineIconPropsNoName = Omit<
  React.ComponentProps<typeof SunshineIcon>,
  'name'
>;

export const ItemIcon: FC<{ icon: IconName } & SunshineIconPropsNoName> = ({
  icon,
  ...props
}) => {
  return (
    <ItemPictureContainer>
      <SunshineIcon size="icon-16" {...props} name={icon} />
    </ItemPictureContainer>
  );
};

const ItemInitials: FC<{ title: string }> = ({ title }) => {
  // Only display alphabetical character in the picture container
  const [firstName, ...rest] = title.replace(/[^a-zA-Z\s]/g, '').split(' ');
  const [lastName] = rest.splice(-1);
  const [firstInitial] = firstName?.toUpperCase() || '';
  const [secondInitial] = lastName?.toUpperCase() || '';

  return (
    <ItemPictureContainer>
      <Text fontSize="font-16" fontWeight="weight-500">
        {firstInitial}
        {secondInitial}
      </Text>
    </ItemPictureContainer>
  );
};

const ItemLogo: FC<{ logo: string }> = ({ logo }) => {
  return (
    <Box aspectRatio={1} borderRadius="radius-full" width="44px">
      <Image src={logo} />
    </Box>
  );
};

export const ItemPicture: FC<{
  icon?: IconName;
  title: string;
  logo?: string;
}> = ({ icon, logo, title }) => {
  if (logo) {
    return <ItemLogo logo={logo} />;
  }

  if (icon) {
    return <ItemIcon icon={icon} />;
  }

  return <ItemInitials title={title} />;
};
